import { Box, Button, styled } from '@mui/material';
import {
  FIXED_FOOTER_HEIGHT,
  SIDE_NAV_WIDTH,
  SUB_NAV_WIDTH,
} from 'src/constants';

export const FooterContainer = styled(Box)(
  ({ theme, $hasSubNav }) => `
  z-index: 100;
  position: fixed;
  bottom: 0;
  left: ${
    $hasSubNav
      ? `calc(${SIDE_NAV_WIDTH}px + ${SUB_NAV_WIDTH}px)`
      : `${SIDE_NAV_WIDTH}px`
  }; //side nav width
  height: ${FIXED_FOOTER_HEIGHT}px;
  border-top: 1px solid ${theme.palette.secondary.lightest};
  width: calc(100% - ${
    $hasSubNav
      ? `calc(${SIDE_NAV_WIDTH}px + ${SUB_NAV_WIDTH}px)`
      : `${SIDE_NAV_WIDTH}px`
  });
  padding: 12px;
  background-color: #ffffff
  `,
);

export const FooterActions = styled(Box)`
  position: relative;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
`;

export const BackButton = styled(Button)`
  position: absolute;
  left: 0;
`;
